import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Solutions from '@/views/Solutions.vue'
import Products from '@/views/Products.vue'
import Cases from '@/views/Cases.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Support from '@/views/Support.vue'
import Industrial from '@/views/solutions/Industrial.vue'
import SmartCity from '@/views/solutions/SmartCity.vue'
import Agriculture from '@/views/solutions/Agriculture.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: Solutions
  },
  {
    path: '/solutions/industrial',
    name: 'Industrial',
    component: Industrial
  },
  {
    path: '/solutions/smart-city',
    name: 'SmartCity',
    component: SmartCity
  },
  {
    path: '/solutions/agriculture',
    name: 'Agriculture',
    component: Agriculture
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/cases',
    name: 'Cases',
    component: Cases
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/support',
    name: 'Support',
    component: Support
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router 